import { Component } from 'react';
import { TabNames } from '../../../services/wss/events/TabNames';

// core components
import CoreComponent from '../../../services/engines/CoreComponent';
import cardPainterManager from '../../../Widgets/DataPainterWidget';

// locals
import YourLibraryTabPainter from './YourLibraryTabPainter';
import floatingPanelEngine from './Core/FloatingPanelEngine';
import './YourLibraryTab.css';

// TIJDELIJK - smoke test, verwijderen na verificatie
// import '../../../UmlWorkspace/UmlClassWidgetSmokeTest';

/**
 * YourLibraryTab — entry point.
 * Composes YourLibraryTabPainter. No local state — all panel management via floatingPanelEngine.
 */
export default class YourLibraryTab extends CoreComponent {
    _name = 'YourLibraryTab';

    componentDidMount() {
        const msg = 'componentWillUnmount';
        this.logDebug('componentDidMount', `${msg}`);

        this.setCurrentTab(TabNames.Library);

        floatingPanelEngine.bootup();
        floatingPanelEngine.getTopics();

        cardPainterManager.bootup();
    }

    componentWillUnmount() {
        const msg = 'componentWillUnmount';
        this.logDebug('componentWillUnmount', `${msg}`);
    }

    render() {
        return <YourLibraryTabPainter />;
    }
}
